const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://fragus.ansof.com.br/';

async function parseJson(response) {
  try {
    return await response.json();
  } catch (e) {
    return { status: 'error', errors: ['Não foi possível interpretar a resposta do servidor.'] };
  }
}

export async function getStaffApplyInfo() {
  const response = await fetch(`${API_BASE_URL}main/staff_apply_info`);
  return parseJson(response);
}

export async function submitStaffApply(fields) {
  const body = new URLSearchParams();
  body.append('name', fields.name);
  body.append('phone', fields.phone);
  body.append('email', fields.email);
  fields.availability.forEach((day) => body.append('availability[]', day));

  const response = await fetch(`${API_BASE_URL}main/staff_apply_submit`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body,
  });

  return parseJson(response);
}

export async function getStaffCompleteInfo(candidate, token) {
  const response = await fetch(`${API_BASE_URL}main/staff_complete_info/${candidate}/${token}`);
  return parseJson(response);
}

export async function getStaffCities(candidate, token, state) {
  const response = await fetch(
    `${API_BASE_URL}main/staff_cities/${candidate}/${token}?state=${encodeURIComponent(state)}`
  );
  return parseJson(response);
}

export async function submitStaffComplete(candidate, token, formData) {
  const response = await fetch(`${API_BASE_URL}main/staff_complete_submit/${candidate}/${token}`, {
    method: 'POST',
    body: formData,
  });

  return parseJson(response);
}

export async function getStaffAvailabilityInfo(candidate, token) {
  const response = await fetch(`${API_BASE_URL}main/staff_availability_info/${candidate}/${token}`);
  return parseJson(response);
}

export async function submitStaffAvailability(candidate, token, action, production) {
  const body = new URLSearchParams();
  body.append('action', action);
  body.append('production', production);

  const response = await fetch(`${API_BASE_URL}main/staff_availability_submit/${candidate}/${token}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body,
  });

  return parseJson(response);
}
